

export default {
  name: 'EoBackgroundSheet',
  props: {
    /**
     * Color of the background
     */
    color: {
      type: String,
      default: null,
    },
    /**
     * Margin top in pixels
     */
    expandUp: {
      type: [String, Number],
      default: 0,
      validator: (value) => {
        return !isNaN(value)
      },
    },
    /**
     * Margin bottom in pixels
     */
    expandDown: {
      type: [String, Number],
      default: 0,
      validator: (value) => {
        return !isNaN(value)
      },
    },
  },
  computed: {
    hasSlot () {
      return !!this.$slots.default
    },
    classes () {
      return {
        'eo-background-sheet': true,
        'is-decorative': !this.hasSlot,
        ['color--' + this.color]: !!this.color,
      }
    },
    styles () {
      return {
        marginTop: '-' + this.dynamicExpandUp,
        marginBottom: '-' + this.dynamicExpandDown,
        paddingTop: this.dynamicExpandUp,
        paddingBottom: this.dynamicExpandDown,
        height: this.dynamicHeight,
      }
    },
    dynamicExpandUp () {
      if (!this.hasSlot) {
        if (this.expandUp || this.expandDown) {
          return `${this.expandUp || this.expandDown}px`
        }
        return '450px'
      } else {
        return `${this.expandUp}px`
      }
    },
    dynamicExpandDown () {
      if (!this.hasSlot) {
        if (this.expandDown || this.expandUp) {
          return `${this.expandDown || this.expandUp}px`
        }
        return '450px'
      } else {
        return `${this.expandDown}px`
      }
    },
    dynamicHeight () {
      if (!this.hasSlot) {
        if (this.expandUp && this.expandDown) {
          return `${parseInt(this.expandUp) + parseInt(this.expandDown)}px`
        } else if (this.expandUp || this.expandDown) {
          return `${parseInt(this.expandUp || this.expandDown) * 2}px`
        }
        return '900px'
      } else {
        return 'auto'
      }
    },
  },
}
